import React from 'react'
import { FormattedMessage } from 'react-intl'
import { ConfirmationRoleAction } from '../../../../legacy-design-system/action'
import { Role } from '@contrast-security-inc/base-types'
import { ConfirmDeleteRouteDialog } from '../../delete-dialog/delete-routes-confirm-dialog'
import { IconDelete } from '@contrast-security-inc/design-system-foundations'
import { ConfirmationRoleActionProps } from '../../../../legacy-design-system/action/confirmation-role-action'

export interface DeleteActionSharedProps
  extends Pick<ConfirmationRoleActionProps, 'size'> {
  readonly organizationUuid: string
  readonly applicationRole: Role
  readonly applicationUuid: string
  readonly onSuccess: () => void
}

export function SharedDeleteAction({
  applicationRole,
  organizationUuid,
  applicationUuid,
  onSuccess,
  number,
  size
}: DeleteActionSharedProps & {
  readonly number: 'single' | 'multiple'
}) {
  return (
    <ConfirmationRoleAction
      size={size}
      data-testid="action_remove"
      isActionValid={true}
      role={applicationRole}
      requiredRole="ADMIN"
      icon={IconDelete}
      iconTooltipMessage={{
        id: 'action_remove'
      }}
      iconTooltipPlacement="top"
      renderDialog={(renderDialogProps) => (
        <ConfirmDeleteRouteDialog
          organizationUuid={organizationUuid}
          applicationUuid={applicationUuid}
          onConfirm={onSuccess}
          renderTitle={() => (
            <FormattedMessage
              id="plural_applicationCoverage_removeRouteTitle"
              values={{ number }}
            />
          )}
          renderBody={() => (
            <FormattedMessage
              id="plural_applicationCoverage_removeRoute"
              values={{ number }}
            />
          )}
          {...renderDialogProps}
        />
      )}
    />
  )
}
